class CreateGroup {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, ASSIGN_USER_CONSTANT, $mdMedia, $mdDialog, $stateParams) {
        this.scope = $scope;
        this.state = $state;
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //[Object] - List of all students in class
        $scope.studentList = [];

        //[Object] - List of student in group
        $scope.groupStudents = [];

        $scope.leader = undefined;
        
        //To get current user id
        let userId = localStorageService.get('user_id')
        let planId = $state.params.planId

        //Object - basic academic details
        let authoringData = localStorageService.get("authoringData")
        let academicDetails = {
            class_id: authoringData.class_id,
            batch_id: authoringData.batch_id,
            subject_id: authoringData.subject_id,
            school_id: authoringData.school_id,
            curriculum_id: authoringData.curriculum_id,
            subject: authoringData.subject,
            class: authoringData.class,
            batch: authoringData.batch,
            session_id: authoringData.session_id,
            session: authoringData.session,
            curriculum: authoringData.curriculum,
            academic_year: authoringData.academic_year,
            user_id: userId
        }

        $scope.isShowWaveFilter = false;

        $scope.isEdit = false;

        $scope.isEdited = false;

        if (academicDetails == null || academicDetails == undefined || academicDetails == '') {
            $state.go('dashboard');
        }

        if ($stateParams.groupId) {
            $scope.isEdit = true;
            /*Meteor.call('getStudentListwithGroupDetails', academicDetails, $stateParams.groupId, (error, result) => {
                if (result) {
            */
            academicDetails['group_id'] = $stateParams.groupId
            authService.callAPI(ASSIGN_USER_CONSTANT.API_STUDENT_GROUP_DETAILS, "POST", academicDetails, function(response) {
                if (response && response.result && response.result.data) {
                    let result = response.result.data.data
                    let studentList = result.studentList;
                    let groupDetails = result.groupDetails;
                    $scope.groupName = groupDetails.group_name;
                    _.each(groupDetails.students, function(student) {
                        let studentDetail = _.find(studentList, function(stu) {
                            return student._id === stu._id
                        })
                        if (studentDetail) {
                            studentDetail.isLeader = student.leader
                            $scope.groupStudents.push(studentDetail)
                            studentList = _.filter(studentList, function(stu) {
                                return student._id !== stu._id
                            })
                        }
                    })
                    let leader = _.find($scope.groupStudents, function(eachStudent) {
                        return eachStudent.isLeader
                    })
                    if (leader)
                        $scope.leader = leader._id;
                    studentList.sort(function(a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                    $scope.studentList = studentList
                    $scope.studentList.sort(function(a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                    $scope.isShowWaveFilter = true;
                    _.defer(function() {
                        $scope.$apply();
                    });;
                }
            });
        } else {
            authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_STUDENT_LIST, "POST", academicDetails, function(response) {
                if (response && response.result && response.result.data) {
                    if (response.result.data.data.length > 0) {
                        $scope.studentList = response.result.data.data
                        $scope.studentList.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        $scope.allstudentList = response.result.data.data

                        $scope.isShowWaveFilter = true;
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }

                }
            });
        }


        $scope.filterStudents = (wave) => {
            let waveStudents = []
            let otherStudents = []
            $scope.isEdited = true
            _.each($scope.allstudentList, function(eachStud, index) {
                let flag = false
                _.each(eachStud.wave, function(eachWave) {
                    if (eachWave.subject_id === academicDetails.subject_id) {
                        if (eachWave.current_wave.wave_id === wave) {
                            waveStudents.push(eachStud)
                            flag = true
                        }

                    }
                })
                if (!flag)
                    otherStudents.push(eachStud)
            })
            $scope.groupStudents = waveStudents
            $scope.groupStudents.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            $scope.studentList = otherStudents
            $scope.studentList.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        }

        /*
         * Function to add student to group
         * 
         * @id : String - id of student to add
         *
         * @return : null
         */
        $scope.addtoGroup = (id) => {
            let index;
            $scope.isEdited = true
            _.each($scope.studentList, function(student, key) {
                if (student._id == id)
                    index = key
            })
            if (index > -1) {
                $scope.groupStudents.push($scope.studentList[index]);
                $scope.studentList.splice(index, 1)
            }
            $scope.groupStudents.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            $scope.studentList.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        }

        /*
         * Function to remove student from group
         * 
         * @id : String - id of student to remove
         *
         * @return : null
         */
        $scope.removefromGroup = (id) => {
            let index;
            $scope.isEdited = true
            _.each($scope.groupStudents, function(student, key) {
                if (student.user_id == id)
                    index = key
            })
            if (index > -1) {
                $scope.studentList.push($scope.groupStudents[index]);
                $scope.groupStudents.splice(index, 1)
            }
            $scope.groupStudents.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            $scope.studentList.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

        }

        $scope.updateEdit = () => {
            $scope.isEdited = true
        }

        $scope.saveGroup = () => {
            let errCount = 0;
            if ($scope.groupName == undefined || $scope.groupName == "") {
                $scope.groupNameError = "Please, Enter Group Name";
                errCount++;
            } else {
                $scope.groupNameError = ""
            }
            if ($scope.groupStudents.length == 0) {
                $scope.studentError = "Please, Add Student(s) for group";
                errCount++;
            } else {
                $scope.studentError = ""
            }
            if (!$scope.leader) {
                $scope.leaderError = "Please, Select Group Leader";
                errCount++;
            } else {
                $scope.leaderError = ""
            }
            if (errCount == 0) {
                if ($scope.groupStudents.length > 0) {
                    let studentList = []
                    // _.each($scope.groupStudents, function(student) {
                    //     if (!student.isLeader) {
                    //         student.isLeader = false
                    //     }
                    //     let obj = {
                    //         _id: student._id,
                    //         name: student.name,
                    //         leader: student.isLeader
                    //     }
                    //     studentList.push(obj)
                    // })
                    _.each($scope.groupStudents, function(student) {
                        let obj = {
                            _id: student._id,
                            name: student.name,
                            leader: student._id === $scope.leader ? true : false
                        }
                        studentList.push(obj)
                    })
                    studentList.sort(function(a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                    if ($scope.isEdit) {
                        let group = {
                            group_name: $scope.groupName,
                            teacher_id: userId,
                            status: 'active',
                            academic_year: academicDetails.academic_year,
                            session_id: academicDetails.session_id,
                            curriculum_id: academicDetails.curriculum_id,
                            subject_id: academicDetails.subject_id,
                            class_id: academicDetails.class_id,
                            batch_id: academicDetails.batch_id,
                            school_id: academicDetails.school_id,
                            assigned_resources: 0,
                            assigned_activity: 0,
                            group_id:$stateParams.groupId,
                            students: studentList
                        }
                        authService.callAPI(ASSIGN_USER_CONSTANT.API_UPDATE_STUDENT_GROUP, "POST", group, function(response) {
                            if (response && response.result && response.result.data) {
                                console.log(response.result.data)
                                toastr.success("Group edited successfully");
                                $state.go('assignUsers', {planId:planId})
                            }
                        })
                    } else {
                        let group = {
                            group_name: $scope.groupName,
                            teacher_id: userId,
                            status: 'active',
                            academic_year: academicDetails.academic_year,
                            session_id: academicDetails.session_id,
                            curriculum_id: academicDetails.curriculum_id,
                            subject_id: academicDetails.subject_id,
                            class_id: academicDetails.class_id,
                            batch_id: academicDetails.batch_id,
                            school_id: academicDetails.school_id,
                            assigned_resources: 0,
                            assigned_activity: 0,
                            students: studentList
                        }
                        authService.callAPI(ASSIGN_USER_CONSTANT.API_ADD_STUDENT_GROUP, "POST", group, function(response) {
                            if (response && response.result && response.result.data) {
                                toastr.success("Group added successfully");
                                $state.go('assignUsers',{planId:planId})
                            }
                        })
                    }
                }
            } else {
                return false;
            }
        }

        $scope.backToGroupList = () => {
            $state.go('assignUsers', $stateParams)
        }


        this.$onDestroy = () => {

        }

    }
}

export default CreateGroup;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/assignUsers/controllers/groupCreationController.js